import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import ChatMessages from './ChatMessages';
import ChatPostForm from './ChatPostForm';
import ChatUsersEditor from './ChatUsersEditor';
import FormInput from '../../Helpers/FormInput';
import stateLinker from '../../../utils/stateLinker';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import CenterScroller from "../../Helpers/CenterScroller";
// import { history } from '../../../history_mobx';
import Heighter from '../../Helpers/Layout/Heighter';
import { inject, observer, reaction } from "mobx-react";
import { makeObservable, observable } from "mobx";
import { checkbox } from "../../../utils/linker";
import { withRouter } from "react-router-dom";

//actions
import closeChatOpenedWindows from '../../../actions/chat/closeChatOpenedWindows';
import setChatMainWindow from '../../../actions/chat/setChatMainWindow';
import setGlobalErrors from '../../../actions/setGlobalErrors';


class ChatWindow extends Component {
  opened=true;
  new_messages=false;
  info=null;
  show_chat_options=false;
  show_chat_users=false;
  show_leave_group=false;
  options={ disable_notify:'0' };

  constructor(props) {
    super(props);
    makeObservable(this,{
      opened: observable,
      new_messages: observable,
      info: observable,
      show_chat_options: observable,
      show_chat_users: observable,
      show_leave_group: observable,
      options: observable,
    });
    this.state = {
      opened:true,
      new_messages:false,
      info:null,
      show_chat_options:false,
      show_chat_users:false,
      show_leave_group:false,
      options:{
        disable_notify:'0'
      }
    };
  }
  /*
  componentDidUpdate(prevProps, prevState, snapshot) {
    
    //Делаем так, чтоб при кнопке "назад" закрывался/открывался наш попап с настройками
    if(this.props.router.location.key !== prevProps.router.location.key && this.state.info) {
      if(this._historyKeyBlock!==history.location.key) {
        this.setState({show_leave_group: false});
      }
    }

    if(!isEqual(this.state.options, prevState.options) && prevState.info) {
      const data={
        disable_notify:this.state.options?'1':''
      };
      axios.post(`/api/privatechat/${this.props.chat_id}/options`,data).then((data) => {});
    }
    
    //обрабатываем сообщения от вебсокетов
    if (this.props.chat_ws && (!prevProps.chat_ws && this.props.chat_ws || (prevProps.chat_ws.timestamp !== this.props.chat_ws.timestamp))) {
      if (this.props.chat_ws.message === 'new_messages') {
        if(this.props.chat_ws.chat_id == this.props.chat_id && !this.state.opened) {
          this.setState({ new_messages:true });
        }
      }
      if (this.props.chat_ws.message === 'user_read_upgrade') {
        if(this.props.chat_ws.chat_id == this.props.chat_id) {
          this.loadInfo();
        }
      }
    }

  }
   */
  loadInfo() {
    axios.get(`/api/privatechat/${this.props.chat_id}`).then((data) => {
      let options={};
      if(data.data.answer) {
        if (this.props.standalone) {
          let chatInfo = cloneDeep(data.data.answer);
          chatInfo.showOptions = () => {
            this.show_chat_users=false;
            this.show_chat_options=true;
          };
          chatInfo.showGroupsEditor = () => {
            this.show_chat_users=true;
            this.show_chat_options=false;
          };
          this.props.chatStore.main_window=chatInfo;
          // this.props.setChatMainWindow(chatInfo);
        }

        this.info=data.data.answer;
        this.options.disable_notify=data.data.answer.chat.chat_user_disable_notify == '1' ? '1' : '0';
        /*this.setState({
          info: data.data.answer,
          options: {
            disable_notify: data.data.answer.chat.chat_user_disable_notify == '1' ? '1' : '0'
          }
        });*/
      }
    });
  }
  componentWillUnmount() {
    if (this.props.standalone) {
      this.props.chatStore.main_window={};
      // this.props.setChatMainWindow({});
    }
  }

  componentWillMount() {
    this.loadInfo();
  }
  toggleChat() {
    if(this.props.standalone) {
      return false;
    }
    /*var newState={
      opened:!this.state.opened
    };*/
    this.opened=!this.opened;
    /*if(newState.opened) {
      newState.new_messages=false;
    }
    this.setState(newState);*/
  }
  closeChat() {
    if(this.props.standalone) {
      this.props.router.push('/chat/');
    } else {
      this.props.chatStore.closeChatWindow(this.props.chat_id);
    }
  }
  getTitle() {
    if(this.info.chat_name === 'one_on_one') {
      const notMe=this.info.items.find((item)=>{
        return item.user_table_nick !== this.props.meStore.me.data.nick;
      });
      return notMe.user_table_nick;
    } else {
      return this.info.chat_name;
    }
  }
  renderTitle() {
    return (
      <div className={`${this.props.standalone?'bg-w1 font1 pleft10 solid1-bottom bo-w2':'bg-b4 w1 pleft10 pointer'} only-s-dn `} onClick={(e)=>{ this.toggleChat(); }}>
        <div className="up12 splice">
          <div className={`cell s-auto s-middle  ${this.props.standalone?'fs30 lh16':'fs13'}`}>
            {this.new_messages?<span className="hpadd5 bg-const2 w1 fs13 rad3">new</span>:null} {this.getTitle()}
          </div>
          {this.info.chat_name !== 'one_on_one'?(
            <div className="cell s-shrink s-middle">
              <i className="mdi mdi-account-multiple chatHeadButton bg-b1-op80-hover pointer" onClick={(e)=>{ e.preventDefault(); e.stopPropagation(); this.show_chat_users=true; this.show_chat_options=false; }}></i>
            </div>
          ):null}
          <div className="cell s-shrink s-middle">
            <i className="mdi mdi-settings chatHeadButton bg-b1-op80-hover pointer" onClick={(e)=>{ e.preventDefault(); e.stopPropagation(); this.show_chat_users=false; this.show_chat_options=true; }}></i>
          </div>
          {this.props.standalone?null:(
            <div className="cell s-shrink s-middle">
              {this.opened?(
                <i className="mdi mdi-window-minimize fs16 pointer w1 pr z3 chatHeadButton bg-b1-op80-hover" onClick={(e)=>{ e.preventDefault(); e.stopPropagation(); this.toggleChat(); }}></i>
              ):(
                <i className="mdi mdi-window-maximize fs16 pointer w1 pr z3 chatHeadButton bg-b1-op80-hover" onClick={(e)=>{ e.preventDefault(); e.stopPropagation(); this.toggleChat(); }}></i>
              )}
            </div>
          )}
          {this.props.standalone?null:(
            <div className="cell s-shrink s-middle">
              <i className="mdi mdi-close fs16 w1 pr z3 pointer chatHeadButton bg-b1-op80-hover" onClick={()=>{ this.closeChat(); }}></i>
            </div>
          )}
        </div>
      </div>
    );
  }
  renderBody() {
    if(this.opened) {
      return (
        <ChatMessages ref={(ref)=>{ this._messagesRef=ref; }} message_id={this.props.message_id} chat_id={this.props.chat_id} info={this.info} height={200} onFetchMessages={(data)=>{  }} standalone={this.props.standalone} />
      )
    }
  }
  renderFormAnswer() {
    if (this.opened) {
      return (
        <ChatPostForm standalone={this.props.standalone} chat_id={this.props.chat_id} onNeedRescroll={()=>{ this._messagesRef.reScroll(); }} />
      )
    }
  }
  renderOptions() {
    return (
      <div>
        <FormInput type="checkbox" title={this.props.translateStore.t.evaPrivateChat.disable_email_notifications}>
          <input type="checkbox" {...checkbox(this.options,'disable_notify')} />
        </FormInput>
        {this.info.chat_name !== 'one_on_one'?(
          <div className="pbottom15">
            <span className="btn6 small" onClick={()=>{ this.props.router.push(window.location.pathname); this._historyKeyBlock=this.props.router.state.key; this.show_leave_group=true; }}><span><i className="mdi mdi-exit-run op50"></i>{this.props.translateStore.t.evaPrivateChat.leave_chat}</span></span>
          </div>
        ):null}
        <div className="tar">
          <span className="btn1" onClick={()=>{ this.show_chat_options=false; }} ><span>Ок</span></span>
        </div>
      </div>
    );
  }
  renderChatUsers() {
    return (
      <ChatUsersEditor standalone={this.props.standalone} chat_id={this.info.chat.id} done={()=>{ this.show_chat_users=false; }} />
    )
  }
  leaveChat() {
    axios.post(`/api/privatechat/${this.props.chat_id}/leave`).then((data)=>{
      if(data.data.errors) {
        this.props.appStateStore.pushGlobalErrors(data.data.errors);
      } else {
        this.closeChat();
      }
    })
  }
  render() {
    if(!this.info) {
      return null;
    }
    return (
      <div className={`${this.props.standalone?'standAloneMode':'fl mright10 solid1 bo-b3 chatWindowWidth'}`}>
        <Heighter height={'auto'} enable={this.props.standalone}>
          <div className="up12-v s-v-nowrap splice h100">
            <div className="v-cell s-v-shrink">
              {this.renderTitle()}
            </div>
            <div className={`v-cell s-v-auto bg-w1 ${this.opened?'chatMessagesColumn':''}`}>
              {this.show_chat_options?(
                <div className="padd10 bg-w1">
                  {this.renderOptions()}
                </div>
              ):null}
              {this.show_chat_users?this.renderChatUsers():null}
              {!this.show_chat_options && !this.show_chat_users?this.renderBody():null}
            </div>
            {!this.show_chat_options && !this.show_chat_users?(
              <div className="v-cell s-v-shrink">
                {this.renderFormAnswer()}
              </div>
            ):null}
          </div>
        </Heighter>

        {this.show_leave_group?(
          <CenterScroller center={true} closeTrigger={()=>{ this.show_leave_group=false; }} maxWidth={500}>
            <div className="padd20 bg-w1">
              <p>{this.props.translateStore.t.evaPrivateChat.v2_chat_leave_chat_descr}</p>
              <div className="up12 margin">
                <div className="cell s-auto"></div>
                <div className="cell s-shrink">
                  <span className="btn2" onClick={()=>{ this.show_leave_group=false; }}><span>{this.props.translateStore.t.evaPrivateChat.cancel}</span></span>
                </div>
                <div className="cell s-shrink">
                  <span className="btn6" onClick={()=>{ this.leaveChat(); }}><span>{this.props.translateStore.t.evaPrivateChat.leave_chat}</span></span>
                </div>
              </div>
            </div>
          </CenterScroller>
        ):null}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    me:state.me,
    chat_ws:state.chat_ws,
    router:state.router,
    t:state.translate,
  }
}

// export default connect(mapStateToProps,{ closeChatOpenedWindows, setGlobalErrors, setChatMainWindow })(ChatWindow);
export default withRouter(inject("translateStore","meStore","chatStore","router","appStateStore")(observer(ChatWindow)));